/**
 * Runtime environment configuration helper
 *
 * Supports two modes:
 * 1. Build-time: Uses Vite's import.meta.env (for local dev)
 * 2. Runtime: Uses window.__RUNTIME_ENV__ (for Docker/K8s)
 *
 * Runtime values take precedence when available.
 */

declare global {
  interface Window {
    __RUNTIME_ENV__?: Record<string, string>
  }
}

export function getEnv(key: string, defaultValue = ''): string {
  // Check runtime config first (Docker/K8s)
  if (typeof window !== 'undefined' && window.__RUNTIME_ENV__?.[key]) {
    return window.__RUNTIME_ENV__[key]
  }

  // Fall back to Vite build-time env
  const viteValue = import.meta.env[key]
  if (viteValue) {
    return viteValue
  }

  return defaultValue
}

// Pre-defined getters for common env vars
export const env = {
  get apiUrl() {
    return getEnv('VITE_API_URL', 'http://localhost:3000/api')
  },
  get frontendUrl() {
    return getEnv('VITE_FRONTEND_URL', 'http://localhost:3333')
  },
  get sentryDsn() {
    return getEnv('VITE_SENTRY_DSN', '')
  },
  get sentryEnvironment() {
    return getEnv('VITE_SENTRY_ENVIRONMENT', 'development')
  },
}
